import { css } from '@bd/bdui-styles/emotion';
import colors from './colors';
import icons from '../components/IconsList';

const forms = css`
  .Form__missingField {
    background-color: yellow;
    padding: 5px;
    color: black;
  }
  Label {
    font-weight: 700;
  }
  .btn {
    border-radius: 0;
    border: none;
    padding: 15px 30px;
    margin: 0;
  }

  .form-col {
    width: 100%;
    margin: 0 0 20px;
    @media (min-width: 992px) {
      width: calc(50% - 20px);
      margin: 0 10px 30px;
    }
  }
  .form-col-fluid {
    width: 100%;
  }

  input, select, textarea {
    border-radius: 0;
    border-color: #B9B9B9;
    height: 54px;
    cursor: pointer;
    @media(min-width: 992px) {
      height: 64px;
    }
  }
  input::placeholder, textarea::placeholder, select::placeholder {
    font-weight: 300;
    font-size: 14px;
    color: #919191;
    letter-spacing: 0;
    line-height: 18px;
    @media(min-width: 992px) {
      font-size: 18px;
    }
  }
  textarea {
    height: 100px;
    @media (min-width: 992px) {
      height: 200px;
    }

  }
  select {
    appearance: none;
    background-image: url(${icons.triangle});
    background-position: calc(100% - 20px) center;
    background-repeat: no-repeat;
    font-weight: 300;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    line-height: 18px;
    @media(min-width: 992px) {
      font-size: 18px;
    }
  }
  select::-ms-expand {
    display: none;
  }
  .Button_wrapper {
    margin: 20px 0;
    display: flex;
    justify-content: flex-end;
    @media (min-width: 992px) {
      margin: 30px 0;
    }
  }

  .Btn_submit {
    position: relative;
    overflow: hidden;
    height: 45px;
    padding: 0 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 15px;
    color: #FFFFFF;
    letter-spacing: 0.12px;
    background-color: ${colors.color1};
    cursor: pointer;
    transition: all .3s ease;
    border: 0;
    @media(min-width: 992px) {
      height: 55px;
      padding: 0 35px;
      font-size: 17px;
      letter-spacing: 0;
    }
    &:focus {
      outline: none;
    }
    &:hover{ 
      transform: scale(1.08);
    }
  }
`;

export default forms;



// WEBPACK FOOTER //
// ./src/styles/forms.js